/*
 * Flex Recordings, js/data.js
 * ------------------------------------------------------------------------
 * Data flow:
 *   releases.json  <-  generated by scripts/sync-bandcamp.js (Bandcamp scrape)
 *   window.FLEX_SEED (below) is the built-in offline fallback catalogue used
 *   only when releases.json cannot be fetched (file://, 404, bad JSON).
 *
 *   FlexData.ready always resolves to a NORMALISED release array, UI code
 *   (app.js) never parses raw sources itself.
 *
 * Shopify note: the same adapter layer will later merge a merch/products feed
 * from the flexdnb.co.uk Shopify Storefront API. Keep ALL source parsing
 * isolated in the pure functions below (normalizeRelease / normalizeAll) so
 * the merch feed can reuse them without touching UI code.
 * ------------------------------------------------------------------------
 */
(function () {
  'use strict';

  var D = window.FlexData || (window.FlexData = {});

  /* ------------------------------------------------------------------ *
   * SEED CATALOGUE (fallback only, releases.json is the source of truth)
   * - Real Bandcamp slugs/URLs from the live /music page (see SPEC.md).
   * - artwork / audioUrl / embedId intentionally null (Bandcamp stream
   *   tokens expire, never persist stream URLs).
   * - Track titles + durations below are SEED PLACEHOLDERS: genre-plausible
   *   DnB/jungle filler so the UI has a tracklist to render. The sync script
   *   replaces them with real Bandcamp trackinfo.
   * - Catalog numbers other than FLEX 30R / FLEX 040 are plausible
   *   placeholders; only £24.99 (30FLEXR vinyl) is a known real price.
   * ------------------------------------------------------------------ */
  var track = function (number, title, duration, artist) {
    return { number: number, title: title, duration: duration, artist: artist || null, audioUrl: null };
  };

  var BC = 'https://flexindustries.bandcamp.com';

  var SEED = [
    {
      id: '30flexr',
      catalogNumber: 'FLEX 30R',
      title: '30FLEXR',
      artist: 'Flex Recordings',
      type: 'vinyl',
      year: 2024,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/30flexr',
      embedId: null,
      price: '£24.99',
      tracks: [
        track(1, 'Steel City Roller', '6:12'),
        track(2, '30 Ton Press', '5:48'),
        track(3, 'Ice Grill', '6:40'),
        track(4, 'Blue Ink Dub', '5:55'),
        track(5, 'Nightbus', '6:21'),
        track(6, 'Deep Blue Pressing', '7:02'),
        track(7, 'Flexin (Vinyl Only)', '5:36'),
        track(8, 'Outro Scroll', '4:44')
      ],
      tags: ['drum-and-bass', 'jungle', 'vinyl', 'rollers'],
      description: 'Eight cuts of pure UK drum & bass pressed on double vinyl: three decades of Flex sound system pressure distilled into one limited run. £24.99 while stock lasts.',
      featured: true,
      typeOverride: null
    },
    {
      id: 'rinse-out-remastered',
      catalogNumber: 'FLEX 074',
      title: 'Rinse Out - Remastered',
      artist: 'Flex Recordings',
      type: 'remaster',
      year: 2021,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/rinse-out-remastered',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Rinse Out (2021 Remaster)', '6:05'),
        track(2, 'Rinse Out (Dub)', '5:52'),
        track(3, 'Forward Motion', '6:33'),
        track(4, 'Rewind Selector', '5:47')
      ],
      tags: ['drum-and-bass', 'remaster', 'rollers'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'lockdown-scrolls-nov-2020',
      catalogNumber: 'FLEX 071',
      title: 'Lockdown Scrolls Nov 2020',
      artist: 'Flex Recordings',
      type: 'archive',
      year: 2020,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/lockdown-scrolls-nov-2020',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Lockdown Dub', '6:18'),
        track(2, 'Empty Roads Roller', '5:59'),
        track(3, 'Basement Scroll', '6:44'),
        track(4, 'Curfew Pressure', '5:31'),
        track(5, 'One Take Wonder', '7:10'),
        track(6, 'Static Signal Dub', '6:02')
      ],
      tags: ['jungle', 'drum-and-bass', 'archive', 'dub'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'more-lost-scrolls-remastered',
      catalogNumber: 'FLEX RMX 01',
      title: 'More Lost Scrolls Remastered',
      artist: 'Flex Recordings',
      type: 'remaster',
      year: 2020,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/more-lost-scrolls-remastered',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Scroll Two', '6:26'),
        track(2, 'Deep Stack Dub', '5:44'),
        track(3, 'Recovered Roller', '6:51'),
        track(4, 'Second Find', '5:38'),
        track(5, 'Remaster Dubplate', '7:04'),
        track(6, 'Archive Dust', '4:58')
      ],
      tags: ['drum-and-bass', 'remaster', 'archive'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'more-tombs-searching-for-lost-scrolls',
      catalogNumber: 'FLEX 068',
      title: 'More Tombs (Searching for Lost Scrolls)',
      artist: 'Flex Recordings',
      type: 'archive',
      year: 2020,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/more-tombs-searching-for-lost-scrolls',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'More Tombs', '6:37'),
        track(2, 'Crypt Walker', '5:50'),
        track(3, 'Dust Cover Dub', '6:14'),
        track(4, 'Search Party Roller', '6:48'),
        track(5, 'Buried Frequency', '7:21')
      ],
      tags: ['jungle', 'drum-and-bass', 'archive', 'dubplate'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'the-l-double-scrolls-remastered',
      catalogNumber: 'FLEX RMX 03',
      title: 'The L Double Scrolls Remastered',
      artist: 'L Double',
      type: 'remaster',
      year: 2019,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/the-l-double-scrolls-remastered',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Scrolls (Main Mix)', '6:30'),
        track(2, 'L Double Dub', '6:02'),
        track(3, 'Tape Side A', '5:45'),
        track(4, 'Warehouse Cut', '6:55'),
        track(5, 'Dat Master Roller', '7:08'),
        track(6, 'Remaster Dub', '5:26')
      ],
      tags: ['drum-and-bass', 'remaster', 'L Double'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'the-lost-remix-scrolls-remastered',
      catalogNumber: 'FLEX RMX 02',
      title: 'The Lost Remix Scrolls Remastered',
      artist: 'Flex Recordings',
      type: 'remaster',
      year: 2019,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/the-lost-remix-scrolls-remastered',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Lost Remix One', '6:11'),
        track(2, 'Lost Remix Two', '5:57'),
        track(3, 'Remix Scroll Dub', '6:40'),
        track(4, 'Alternate Cut', '6:22'),
        track(5, 'Remaster Version', '5:49')
      ],
      tags: ['drum-and-bass', 'remaster', 'archive'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'flex-archives-remastered-vol-1-10',
      catalogNumber: 'FLEX ARC 01',
      title: 'Flex_Archives_Remastered_Vol_1-10',
      artist: 'Flex Recordings',
      type: 'remaster',
      year: 2018,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/flex-archives-remastered-vol-1-10',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Vol 1 - Renegade Siren', '6:35'),
        track(2, 'Vol 2 - Blue Ink', '6:08'),
        track(3, 'Vol 3 - Pressing Plant Dub', '5:52'),
        track(4, 'Vol 4 - Tapeside B', '6:47'),
        track(5, 'Vol 5 - Low Tide Roller', '7:15'),
        track(6, 'Vol 6 - Smoke Signal', '5:39'),
        track(7, 'Vol 7 - Deadstock Dub', '6:29'),
        track(8, 'Vol 8 - Final Cut', '7:02')
      ],
      tags: ['drum-and-bass', 'remaster', 'archive'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'lost-scrolls-dub-plates-white-labels',
      catalogNumber: 'FLEX 055',
      title: 'Lost Scrolls - Dub plates & white labels',
      artist: 'Flex Recordings',
      type: 'archive',
      year: 2017,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/lost-scrolls-dub-plates-white-labels',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Dubplate One', '6:20'),
        track(2, 'White Label Test Press', '5:54'),
        track(3, 'Acetate Dub', '6:46'),
        track(4, 'Lost Scroll', '6:05'),
        track(5, 'Unreleased Roller', '7:12'),
        track(6, 'Dubplate Pressure', '5:41'),
        track(7, 'Unknown Label Copy', '6:33')
      ],
      tags: ['jungle', 'drum-and-bass', 'archive', 'dubplate', 'white label'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'roughcut-killa-beats-vol-2',
      catalogNumber: 'FLEX 032',
      title: 'Roughcut Killa Beats Vol 2',
      artist: 'Roughcut',
      type: 'digital',
      year: 2016,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/roughcut-killa-beats-vol-2',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Killa Beats', '5:44'),
        track(2, 'Roughcut Roller', '6:18'),
        track(3, 'Jump Up Ting', '5:26'),
        track(4, 'Skanka', '6:02'),
        track(5, 'Bassline Brawl', '5:55'),
        track(6, 'Wobble Shop', '6:31'),
        track(7, 'Killa Beat VIP', '5:37'),
        track(8, 'Soundboy Run', '6:49')
      ],
      tags: ['drum-and-bass', 'jump-up', 'rollers', 'Roughcut'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'flex-p-i-c-t-001-24bit-remasters',
      catalogNumber: 'FLEX PICT 001',
      title: 'FLEX P.I.C.T 001 [24bit Remasters]',
      artist: 'L Double',
      type: 'remaster',
      year: 2015,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/flex-p-i-c-t-001-24bit-remasters',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'P.I.C.T (Main)', '6:24'),
        track(2, 'L Double Dub Mix', '5:58'),
        track(3, '24bit Roller', '6:41'),
        track(4, 'Picture Disc Dub', '6:06'),
        track(5, 'Reel One', '7:19')
      ],
      tags: ['drum-and-bass', 'remaster', '24bit', 'L Double'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'ltd-flex-24-bit-remasters',
      catalogNumber: 'FLEX LTD 01',
      title: 'LTD FLEX [24 bit Remasters]',
      artist: 'Flex Recordings',
      type: 'remaster',
      year: 2014,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/ltd-flex-24-bit-remasters',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'LTD Edition', '6:16'),
        track(2, 'Limited Pressing Dub', '5:47'),
        track(3, '24 Bit Roller', '6:52'),
        track(4, 'Numbered Copy', '5:33')
      ],
      tags: ['drum-and-bass', 'remaster', '24bit'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'dubwize-selection-vol-2',
      catalogNumber: 'FLEX 028',
      title: 'Dubwize selection Vol 2',
      artist: 'Flex Recordings',
      type: 'digital',
      year: 2013,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/dubwize-selection-vol-2',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Dubwize Selection', '6:28'),
        track(2, 'Sound System Dub', '6:53'),
        track(3, 'Steppers Roller', '5:42'),
        track(4, 'Dubwise VIP', '6:15'),
        track(5, 'Channel One Stepper', '7:06'),
        track(6, 'Echo Chamber', '5:50'),
        track(7, 'Version Excursion', '6:38')
      ],
      tags: ['drum-and-bass', 'dub', 'soundsystem'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'deepest-cut-24bit-remasters',
      catalogNumber: 'FLEX RMX 05',
      title: 'Deepest Cut 24bit Remasters',
      artist: 'Flex Recordings',
      type: 'remaster',
      year: 2012,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/deepest-cut-24bit-remasters',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Deepest Cut', '6:44'),
        track(2, 'Deep Cut Dub', '6:09'),
        track(3, '24bit Deep Roller', '7:00'),
        track(4, 'Sub Bass Pressure', '5:56'),
        track(5, 'Remaster Version', '6:27')
      ],
      tags: ['drum-and-bass', 'remaster', '24bit', 'rollers'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'flex-040-ricky-force-real-love-nice-n-easy',
      catalogNumber: 'FLEX 040',
      title: 'Flex 040 - Ricky Force Real love/Nice n easy',
      artist: 'Ricky Force',
      type: 'ep',
      year: 2008,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/flex-040-ricky-force-real-love-nice-n-easy',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Real Love', '6:34'),
        track(2, 'Nice N Easy', '6:12'),
        track(3, 'Real Love (Dub Mix)', '6:20')
      ],
      tags: ['drum-and-bass', 'jungle', 'Ricky Force'],
      description: '',
      featured: false,
      typeOverride: null
    },
    {
      id: 'little-rollers-vol-1',
      catalogNumber: 'FLEX 012',
      title: 'Little Rollers Vol 1',
      artist: 'L Double',
      type: 'digital',
      year: 2005,
      artwork: null,
      audioUrl: null,
      bandcampUrl: BC + '/album/little-rollers-vol-1',
      embedId: null,
      price: null,
      tracks: [
        track(1, 'Little Roller One', '6:22'),
        track(2, 'Little Roller Two', '6:05'),
        track(3, 'Small Wheel Skank', '5:48'),
        track(4, 'Rollercoaster Dub', '6:56'),
        track(5, 'Little Roller VIP', '5:39'),
        track(6, 'Wheel Up Again', '6:31')
      ],
      tags: ['drum-and-bass', 'jungle', 'rollers', 'L Double'],
      description: '',
      featured: false,
      typeOverride: null
    }
  ];

  /* ------------------------------------------------------------------ *
   * Categorisation (SPEC, first match wins):
   *   1. title matches /remaster|24 ?bit/i  -> remaster
   *   2. /archiv|scroll|lost|dub ?plate|white label/i -> archive
   *   3. /vinyl|12"|lp/i                    -> vinyl
   *   4. trackCount < 5                     -> ep
   *   5. else                               -> digital
   * A non-null typeOverride always wins.
   * ------------------------------------------------------------------ */
  var RE_REMASTER = /remaster|24 ?bit/i;
  var RE_ARCHIVE = /archiv|scroll|lost|dub ?plate|white label/i;
  var RE_VINYL = /vinyl|12"|lp/i;

  function deriveType(title, trackCount) {
    var t = String(title || '');
    if (RE_REMASTER.test(t)) return 'remaster';
    if (RE_ARCHIVE.test(t)) return 'archive';
    if (RE_VINYL.test(t)) return 'vinyl';
    if (trackCount < 5) return 'ep';
    return 'digital';
  }

  function str(v) {
    if (typeof v === 'string') return v.trim();
    if (v == null) return null;
    return v;
  }

  /* Keep ALL source parsing in these pure functions, the future Shopify
   * merch feed goes through the same normalisation layer. */
  /* Copy rule: em/en dashes never ship to the UI. Plain hyphen instead. */
  function noDashes(s) {
    return s ? s.replace(/[\u2014\u2013]/g, '-').replace(/ {2,}/g, ' ') : s;
  }

  function normalizeRelease(raw, index) {
    var r = raw && typeof raw === 'object' ? raw : {};
    var slug = String(str(r.bandcampUrl) || '').replace(/^.*\/album\//, '');
    var id = str(r.id) || slug || 'release-' + (index + 1);
    var title = noDashes(str(r.title)) || id;
    var artist = noDashes(str(r.artist)) || 'Flex Recordings';
    var year = parseInt(r.year, 10);

    var tracks = (Array.isArray(r.tracks) ? r.tracks : []).map(function (t, ti) {
      var tr = t && typeof t === 'object' ? t : {};
      var num = parseInt(tr.number, 10);
      return {
        number: isNaN(num) ? ti + 1 : num,
        title: noDashes(str(tr.title)) || 'Track ' + (ti + 1),
        artist: noDashes(str(tr.artist)) || artist,
        duration: str(tr.duration) || null, // "m:ss" strings pass through untouched
        audioUrl: str(tr.audioUrl) || null
      };
    });

    var typeOverride = str(r.typeOverride) || null;
    var type = typeOverride || str(r.type) || deriveType(title, tracks.length);

    return {
      id: id,
      catalogNumber: noDashes(str(r.catalogNumber)),
      title: title,
      artist: artist,
      type: type,
      year: isNaN(year) ? null : year,
      date: str(r.date) || null,
      artwork: str(r.artwork) || null,
      audioUrl: str(r.audioUrl) || null,
      bandcampUrl: str(r.bandcampUrl) || '',
      embedId: str(r.embedId) || null,
      price: str(r.price),
      tracks: tracks,
      tags: (Array.isArray(r.tags) ? r.tags : []).map(function (t) { return str(t); }).filter(Boolean),
      description: noDashes(str(r.description)) || '',
      featured: Boolean(r.featured),
      typeOverride: typeOverride
    };
  }

  function normalizeAll(list) {
    var out = (Array.isArray(list) ? list : []).map(normalizeRelease);
    out.sort(function (a, b) {
      // Newest cuts first: ISO dates compare lexically; undated fall back to year.
      var da = a.date || '', db = b.date || '';
      if (da !== db) return da < db ? 1 : -1;
      var ya = a.year == null ? -Infinity : a.year;
      var yb = b.year == null ? -Infinity : b.year;
      if (yb !== ya) return yb - ya; // year desc (nulls last)
      return a.title.localeCompare(b.title, 'en', { sensitivity: 'base' }); // title asc
    });
    return out;
  }

  /* ------------------------------------------------------------------ *
   * Formatters (exposed as FlexData.format; SPEC name FORMATTERS aliased)
   * ------------------------------------------------------------------ */
  function fromSeconds(total) {
    var m = Math.floor(total / 60);
    var s = total % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function fmtDuration(input) {
    if (input == null || input === '') return '0:00';
    if (typeof input === 'number' && isFinite(input)) {
      return fromSeconds(Math.max(0, Math.round(input)));
    }
    var s = String(input).trim();
    if (/^\d{1,2}:\d{2}(:\d{2})?$/.test(s)) {
      var parts = s.split(':').map(Number);
      if (parts.length === 3) return fromSeconds(parts[0] * 3600 + parts[1] * 60 + parts[2]);
      return fromSeconds(parts[0] * 60 + parts[1]); // already "m:ss", normalised passthrough
    }
    var n = Number(s);
    return isFinite(n) ? fromSeconds(Math.max(0, Math.round(n))) : '0:00';
  }

  var KNOWN_TYPES = { vinyl: 'VINYL', digital: 'DIGITAL', remaster: 'REMASTER', archive: 'ARCHIVE', ep: 'EP' };

  function typeBadge(type) {
    var t = str(type);
    if (!t) return 'RELEASE';
    var known = KNOWN_TYPES[String(t).toLowerCase()];
    return known || String(t).toUpperCase();
  }

  D.format = { fmtDuration: fmtDuration, typeBadge: typeBadge };
  D.FORMATTERS = D.format; // SPEC alias, same object

  /* ------------------------------------------------------------------ *
   * ready: releases.json first (source of truth), seed on ANY failure.
   * ------------------------------------------------------------------ */
  D.ready = new Promise(function (resolve) {
    var fail = function (reason) {
      console.warn(
        '[FlexData] Could not load releases.json (' + reason + '). Serving the built-in seed catalogue. ' +
        'If you are viewing via file://, run a local server (e.g. `python3 -m http.server`) to load releases.json.'
      );
      resolve(normalizeAll(window.FLEX_SEED || SEED));
    };

    try {
      if (typeof fetch !== 'function') { fail('fetch unsupported'); return; }
      // Shopify builds set window.FLEX_RELEASES_URL to the CDN asset_url; local/Vercel use the default.
      fetch(window.FLEX_RELEASES_URL || 'releases.json', { cache: 'no-store' })
        .then(function (res) {
          if (!res.ok) { fail('HTTP ' + res.status); return null; }
          return res.json();
        })
        .then(function (json) {
          if (!json) return; // already failed above
          if (!json || !Array.isArray(json.releases)) { fail('unexpected payload'); return; }
          resolve(normalizeAll(json.releases));
        })
        .catch(function () { fail('network or parse error (file://?)'); });
    } catch (e) {
      fail('fetch threw');
    }
  });

  // Seed exposed for debugging/tests; UI must use FlexData.ready only.
  window.FLEX_SEED = SEED;
})();
